import { Button, InlineError, Input, Spinner } from 'avo-ui'
import TabToggle from 'components/commons/tab-toogle'

export const SEO = ({ SEODetail, errorForm, onChangeForm, isLoading, isUpdating, onSubmit }) => {
    return isLoading ? (
        <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
    ) : (
        <>
            <TabToggle
                title={'General'}
                content={
                    <div className={'flex flex-col space-y-5 w-1/2'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Meta Title</div>
                            <Input
                                className={'flex-1'}
                                name={'title'}
                                placeholder={'Masukkan meta title'}
                                value={SEODetail?.title}
                                onChange={onChangeForm}
                            />
                            <InlineError className='mt-2' message={errorForm?.title} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Meta Description</div>
                            <Input
                                type={'text-area'}
                                className={'flex-1'}
                                name={'description'}
                                placeholder={'Masukkan meta description'}
                                value={SEODetail?.description}
                                row={5}
                                onChange={onChangeForm}
                            />
                            <InlineError className='mt-2' message={errorForm?.description} />
                        </div>
                    </div>
                }
            />
            <div className={'flex justify-end w-[calc(100%-544px)] py-3 bg-white fixed bottom-0 right-9 z-20'}>
                <Button
                    className={'w-[200px] !bg-gradient-to-r !from-[#06308D] !to-[#3C6CD6] !border-neutral-20'}
                    loading={isUpdating}
                    title={'SAVE ALL CHANGES'}
                    onClick={onSubmit}
                />
            </div>
        </>
    )
}
